import { Dispatch, SetStateAction } from "react";
import Nav from "react-bootstrap/Nav";
import { IOrganizacao } from "../../../../Interfaces/Organizacao/Organizacao";

interface IOrganizacaoNavBar {
    setTabAtivado: Dispatch<SetStateAction<string>>;
    infoOrganizacao: IOrganizacao | undefined;
}

export default function InfoNavBar(props: IOrganizacaoNavBar) {
    const logo = props.infoOrganizacao?.DS_URL_LOGO
        ? `https://crm.capys.com.br${props.infoOrganizacao.DS_URL_LOGO.replace(
              "~",
              ""
          )}`
        : "";

    return (
        <div className="card card-custom">
            <div className="d-flex flex-column card-header">
                <div className="d-flex align-items-center  justify-content-center">
                    <div className="symbol symbol-100 mr-5 my-8">
                        <img
                            src={logo}
                            alt={
                                props.infoOrganizacao?.DS_NOME_FANTASIA +
                                " logo"
                            }
                            className="orgImg"
                        />
                    </div>
                </div>
                <span className="font-size-h6 font-weight-bold text-dark mb-4">
                    <strong>Razão Social:</strong>{" "}
                    {props.infoOrganizacao?.DS_RAZAO_SOCIAL}
                </span>
                <span className="font-size-h6 font-weight-bold text-dark mb-4">
                    <strong>Nome Fantasia:</strong>{" "}
                    {props.infoOrganizacao?.DS_NOME_FANTASIA}
                </span>
                <span className="font-size-h6 font-weight-bold text-dark mb-4">
                    <strong>Email:</strong> {props.infoOrganizacao?.DS_EMAIL}
                </span>
                <span className="font-size-h6 font-weight-bold text-dark mb-4">
                    <strong>Telefone:</strong>{" "}
                    {props.infoOrganizacao?.NR_TELEFONE}
                </span>
            </div>
            <div className="card-body">
                <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                        <Nav.Link
                            eventKey="infoGeral"
                            onClick={() => props.setTabAtivado("infoGeral")}
                        >
                            Informações Gerais
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="infoEndereco"
                            onClick={() => props.setTabAtivado("infoEndereco")}
                        >
                            Endereço
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="infoERP"
                            onClick={() => props.setTabAtivado("infoERP")}
                        >
                            Integração ERP
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="infoEmail"
                            onClick={() => props.setTabAtivado("infoEmail")}
                        >
                            Configurações de E-mail
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
        </div>
    );
}
